"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _index = _interopRequireDefault(require("@/components/echarts/index"));
var _statistic = require("@/api/statistic");
var _vueCountTo = _interopRequireDefault(require("vue-count-to"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    echartsFrom: _index.default,
    countTo: _vueCountTo.default
  },
  data: function data() {
    return {
      xAxis: [],
      yAxis: {
        type: 'value'
      },
      series: [{
        data: [],
        type: 'line'
      }],
      dataTitlelist: [{
        name: '待发货单量',
        value: ''
      }, {
        name: '售后中订单',
        value: ''
      }],
      dataRight: [{
        name: '本周新增供应商',
        value: ''
      }, {
        name: '本周新增SPU',
        value: ''
      }, {
        name: '本周新增SKU',
        value: ''
      }, {
        name: '总单量',
        value: ''
      }, {
        name: '总金额',
        value: ''
      }, {
        name: '本月新增供应商',
        value: ''
      }, {
        name: '本月新增SPU',
        value: ''
      }, {
        name: '本月新增SKU',
        value: ''
      }, {
        name: '售后订单量',
        value: ''
      }, {
        name: '售后总金额',
        value: ''
      }]
    };
  },
  mounted: function mounted() {
    var _this = this;
    (0, _statistic.getPurchaseData)().then(function (res) {
      var echartOrderList = res.echartOrderList;
      _this.xAxis = echartOrderList.map(function (_ref) {
        var date = _ref.date;
        return date;
      });
      _this.series[0].data = echartOrderList.map(function (_ref2) {
        var totalPrice = _ref2.totalPrice;
        return totalPrice;
      });
      var titleDataMap = {
        '待发货单量': res.pendingShippingOrderNum,
        '售后中订单': res.doingAfterSaleOrderNum
      };
      _this.dataTitlelist.forEach(function (item) {
        item.value = titleDataMap[item.name] || 0;
      });
      var rightDataMap = {
        '本周新增供应商': res.weekNewSupplierNum,
        '本周新增SPU': res.weekNewSpuNum,
        '本周新增SKU': res.weekNewSkuNum,
        '总单量': res.totalOrderNum,
        '总金额': res.totalOrderAmount,
        '本月新增供应商': res.monthNewSupplierNum,
        '本月新增SPU': res.monthNewSpuNum,
        '本月新增SKU': res.monthNewSkuNum,
        '售后订单量': res.afterSaleOrderNum,
        '售后总金额': res.afterSaleOrderAmount
      };
      console.log(rightDataMap, 'rightDataMap');
      _this.dataRight.forEach(function (item) {
        item.value = rightDataMap[item.name] || 0;
      });
    });
  },
  methods: {}
};